import { render, staticRenderFns } from "./TeamsManagement.vue?vue&type=template&id=1b8d6a6d&"
import script from "./TeamsManagement.vue?vue&type=script&lang=js&"
export * from "./TeamsManagement.vue?vue&type=script&lang=js&"
import style0 from "./TeamsManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports